import { type FC } from 'react';

import { Box } from '@shared/ui-kit';

import { type MerchantsListWithTotalResponse } from '@api/services/merchants';

import { MerchantCard } from '../../card';
import { useVirtualizedMerchantsList } from '../hooks';

import {
  MerchantsListEmptyState,
  MerchantsListErrorState,
  MerchantsListLoader,
} from './_components';

interface Props {
  loading: boolean;
  error: boolean;
  merchants: Required<NonNullable<MerchantsListWithTotalResponse['result']>>;
}

const MerchantsList: FC<Props> = (props) => {
  const { loading, error, merchants } = props;

  const { listRef, virtualizer } = useVirtualizedMerchantsList(merchants.items);

  const items = virtualizer.getVirtualItems();

  if (error) return <MerchantsListErrorState />;
  if (loading) return <MerchantsListLoader />;
  if (!merchants || !merchants.items.length) return <MerchantsListEmptyState />;

  return (
    <Box
      ref={listRef}
      data-testid="merchants-list"
    >
      <Box
        pos="relative"
        w="full"
        h={`${virtualizer.getTotalSize()}px`}
      >
        {items.map(({ index, start, key }) => {
          const merchant = merchants.items[index];

          return (
            <Box
              ref={virtualizer.measureElement}
              key={key}
              data-index={index}
              pos="absolute"
              top="0"
              left="0"
              w="full"
              transform={`translateY(${start - virtualizer.options.scrollMargin}px)`}
            >
              <MerchantCard merchant={merchant} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default MerchantsList;
